import ArticleLayout from '@/pages/article/components/ArticleLayout';
import { allArticles } from '@/mocks/articles';

export default function SugargooTipsTricksPage() {
  const article = allArticles.find(a => a.slug === 'sugargoo-tips-tricks')!;
  return <ArticleLayout article={article} />;
}